import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ConfigurationService } from './configuration.service';
import { NotifMessageService } from './notifmessage.service';
import { Observable, of, Subject } from 'rxjs';
import { Items } from '../models/items';
import * as moment from 'moment';
import { catchError } from 'rxjs/operators';
import { Event } from '../models/event';
import { UtilsService } from './utils.service';

@Injectable({
  providedIn: 'root'
})
export class ErrorService {

  errorSubject = new Subject<any[]>();
  errorSubjectPager = new Subject<Items<Event>>();

  emitErrorPager(events) {
    this.errorSubjectPager.next(events);
  }

  emitError(criteria) {
    this.errorSubject.next(criteria);
  }

  constructor(private http: HttpClient,
    private configService: ConfigurationService,
    private notifService: NotifMessageService,
    private utilsService: UtilsService) { }

  findByCriteria(criteria, pager): Observable<Items<Event>> {
    this.utilsService.updateCriteriaWindowFromTo(criteria);
    let params = {};
    Object.assign(params, pager, criteria);

    return this.http.get<Items<Event>>(this.configService.config.urlAPI.urlEvent, { params: params }).pipe(catchError(err => {
      console.log("error findBYCriteria", err);
      this.notifService.notifyErrorWithDetailFromApi('ERROR_EVENT_API', err);
      let emptyList = new Items<Event>();
      emptyList.content = [];
      return of(emptyList);
    }));
  }


  downloadFile(data, filename = 'data') {
    let csvData = this.convertToCSV(data);
    let blob = new Blob(['\ufeff' + csvData], { type: 'text/csv;charset=utf-8;' });
    let dwldLink = document.createElement("a");
    let url = URL.createObjectURL(blob);
    let isSafariBrowser = navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Chrome') == -1;
    if (isSafariBrowser) {  //if Safari open in new window to save file with random filename.
      dwldLink.setAttribute("target", "_blank");
    }
    dwldLink.setAttribute("href", url);
    dwldLink.setAttribute("download", filename + ".csv");
    dwldLink.style.visibility = "hidden";
    document.body.appendChild(dwldLink);
    dwldLink.click();
    document.body.removeChild(dwldLink);
  }

  ev = new Object();

  convertToCSV(objArray) {
    this.ev = {
      id: "",
      objectToSend: "",
      eventType: "",
      createdDate: "",
      userContext: "",
      eventSource: "",
      objectToSendType: "",
      errorCode: "",
      errorI18nKey: "",
      eventCategory: "",
      correlationId: "",
      posId: 0,
      supplierId: 0,
      merchantId: 0
    };
    let array = typeof objArray != 'object' ? JSON.parse(objArray) : objArray;
    const separator = ',';
    const keys = Object.keys(this.ev);
    const csvData =
      keys.join(separator) +
      '\n' +
      array.map(row => {
        return keys.map(k => {
          let cell = row[k] === null || row[k] === undefined ? '' : row[k];
          if (cell instanceof Array && cell.length > 0) {
            let values = cell.map(o => Object.values(o).join(',')).join('\t');
            cell = values;
          }
          cell = cell instanceof Date
            ? cell.toLocaleString()
            : cell.toString().replace(/"/g, '""');

          if (cell.search(/("|,|\n)/g) >= 0) {
            cell = `"${cell}"`;
          }
          return cell;
        }).join(separator);
      }).join('\n');
    return csvData;
  }
}
